import { useEffect, useState } from 'react'

import RozmowaService from '@/services/RozmowaService'

const POLL_INTERVAL_MS = 5000

const LIVE_DETAIL_FIELDS = [
	'analiza',
	'summary',
	'podsumowanie',
	'streszczenie',
	'ai_summary',
	'aiSummary',
	'ai_podsumowanie',
	'aiPodsumowanie',
	'podsumowanie_ai',
	'podsumowanieAi',
	'call_summary',
	'callSummary',
	'conversation_summary',
	'conversationSummary',
	'rozmowa_summary',
	'rozmowaSummary',
	'transkrypt',
	'transcript',
	'transcription',
	'transkrypcja',
	'transkrypcje',
	'call_transcript',
	'callTranscript',
	'stt',
	'tekst_transkrypcji',
	'tekstTranskrypcji',
	'kroki',
	'next_steps',
	'nextSteps',
	'nastepne_kroki',
	'nastepneKroki',
	'twilio_call_status',
	'twilioCallStatus',
	'call_status',
	'callStatus',
	'twilio_call_duration',
	'twilioCallDuration',
	'call_duration',
	'callDuration',
	'nagranie_url',
	'nagranieUrl',
	'nagranie',
	'recording_url',
	'recordingUrl',
	'recording',
	'call_recording',
	'callRecording',
	'audio_url',
	'audioUrl',
]

const pickLiveDetailFields = data => {
	if (!data || typeof data !== 'object') return null

	const fields = {}

	for (const field of LIVE_DETAIL_FIELDS) {
		if (data[field] !== undefined) {
			fields[field] = data[field]
		}
	}

	return Object.keys(fields).length > 0 ? fields : null
}

export default function useRozmowaAnalysisPolling(rozmowa) {
	const rozmowaId = rozmowa?._id || rozmowa?.id
	const [liveFields, setLiveFields] = useState(null)

	useEffect(() => {
		setLiveFields(null)
	}, [rozmowaId])

	useEffect(() => {
		if (!rozmowaId) return undefined

		let active = true
		let inFlight = false

		const poll = async () => {
			if (inFlight) return

			inFlight = true

			try {
				const result = await RozmowaService.getById(rozmowaId)

				if (!active || result?.error) return

				const nextFields = pickLiveDetailFields(result?.data)
				if (!nextFields) return

				setLiveFields(nextFields)
			} finally {
				inFlight = false
			}
		}

		const timerId = setInterval(poll, POLL_INTERVAL_MS)

		return () => {
			active = false
			clearInterval(timerId)
		}
	}, [rozmowaId])

	if (!rozmowa) return null
	if (!liveFields) return rozmowa

	return {
		...rozmowa,
		...liveFields,
	}
}
